import { css, styled } from 'styled-components';

import { RichText } from '#/components/Text/RichText';
import {
  colors,
  cssBreakpoints,
  fontWeights,
  gutterWidth,
} from '#/theme/theme';

const containerWithDividerCss = css`
  border-bottom: solid 1px ${colors.elementGrey};

  &:last-child {
    border-bottom: 0;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    border-bottom: none;
    border-right: solid 1px ${colors.elementGrey};

    &:last-child {
      border-right: 0;
    }
  }
`;

export const CmsThreeStepCtaBlockStepHolder = styled.div<{
  $large: boolean;
  $withLinks: boolean;
}>`
  width: 100%;
  padding: ${gutterWidth / 2}px 0;

  @media (min-width: ${cssBreakpoints.mdUp}) {
    width: 33.33%;
    padding: 0 ${gutterWidth / 2}px;
  }

  ${(props) =>
    props.$large || props.$withLinks ? '' : containerWithDividerCss}
`;

export const CmsThreeStepCtaBlockHeadlineStyledRichText = styled(RichText)`
  font-size: inherit;

  p {
    line-height: 1.25;
    margin: 0;
    font-size: inherit;
    font-weight: ${fontWeights.semiBold};
  }
`;

export const CmsTreeStepCtaBlockStep_Box_1 = styled.div`
  margin-bottom: -16px;

  &[data-not-large-or-with-links] {
    @media all and (min-width: ${cssBreakpoints.smUp}) {
      padding-inline: ${gutterWidth / 4}px;
    }
  }
`;

export const CmsTreeStepCtaBlockStep_Box_2 = styled.div`
  &[data-not-large-or-with-links] {
    @media all and (min-width: ${cssBreakpoints.smUp}) {
      padding-inline: ${gutterWidth / 4}px;
    }
  }
`;
